import ThinkLoadMore from './wp-load-more';

document.addEventListener('DOMContentLoaded', () => {
  const loadMore = document.querySelector('.load-more-box');
  if (loadMore) {
    window.grplusLoadMore = new ThinkLoadMore({
      classPrefix: 'load-more-box',
      ajaxAction: loadMore.getAttribute('data-tlmore-action'),
      filterResponseData: (data) => data,
      findParamsBeforeLoad: () => {
        const searchForm = document.getElementById('search-form');
        const filterForm = document.getElementById('filter-form');

        const data = {};

        if (searchForm) {
          const searchTextEl = searchForm.querySelector('[name="search"]');
          if (searchTextEl && searchTextEl.value && searchTextEl.value.length > 0) {
            data.search = searchTextEl.value;
          }
        }

        if (filterForm) {
          let hasFilter = false;
          const checkboxesNames = [
            'product_brand',
          ];

          checkboxesNames.forEach((name) => {
            const items = [];
            filterForm.querySelectorAll(`[name="${name}[]"]:checked`)
              .forEach((el) => {
                items.push(el.value);
              });
            if (items.length > 0) {
              hasFilter = true;
              data[name] = items;
            }
          });

          document.body.classList.toggle('search-filter__has-filters', hasFilter);
        }

        const listingOrder = document.querySelector('[name="listing-order"]');
        if (listingOrder) {
          data.order = listingOrder.value;
        }

        return data;
      },
      onRequestFinally: () => {
        if (window.lazyLoadInstance) {
          window.lazyLoadInstance.update();
        }
      },
    });
  }

  document.addEventListener('click', (e) => {
    if (e.target
            && e.target.closest('.load-more-box__show-all')
    ) {
      e.preventDefault();
      grplusLoadMore.loadMore({ paged: 1, per_page: 'all' });
    }
  });

  const filterForm = document.getElementById('filter-form');
  if (filterForm) {
    filterForm.addEventListener('submit', (e) => {
      e.preventDefault();
      if (typeof grplusLoadMore !== 'undefined') {
        grplusLoadMore.loadMore({ paged: 1 });
      }
    });

    filterForm.querySelectorAll('input[type="checkbox"]')
      .forEach((trigger) => {
        trigger.addEventListener('change', () => {
          grplusLoadMore.loadMore({ paged: 1 });
        });
      });
    document.querySelectorAll('.clear-filter-form')
      .forEach((trigger) => {
        trigger.addEventListener('click', (e) => {
          e.preventDefault();
          filterForm.reset();
          if (typeof grplusLoadMore !== 'undefined') {
            grplusLoadMore.loadMore({ paged: 1 });
          }
        });
      });
  }
  const listingOrder = document.querySelector('[name="listing-order"]');
  if (listingOrder) {
    listingOrder.addEventListener('change', (e) => {
      e.preventDefault();
      if (typeof grplusLoadMore !== 'undefined') {
        grplusLoadMore.loadMore({ paged: 1 });
      }
    });
  }
  if (document.getElementById('loadMoreOnLoad')) {
    grplusLoadMore.loadMore({ paged: 1 });
  }
});
